export default "__VITE_ASSET__D40$Ks6b__"